// extracted by mini-css-extract-plugin
export default {"navLinks":"navLinks_navLinks__1hLCE","navLinksVertical":"navLinks_navLinksVertical__y2isO","dropdownItem":"navLinks_dropdownItem__jWGYE","navTitle":"navLinks_navTitle__2NBsJ"};